import ArticlesList from 'components/ArticlesList';
import OctobreRoseCard from 'components/cards/OctobreRoseCard';
import InfoHome from 'components/info/InfoHome';
import { useCategoryPage } from 'components/info/queries';
import { Page, PageContent } from 'components/layout/page';
import PageTopBar from 'components/navigation/PageTopBar';
import { Empty, EmptyDescription, EmptyHeader } from 'components/ui/empty';
import { Skeleton } from 'components/ui/skeleton';
import useScrollRestoration from 'hooks/useScrollRestoration';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { INFO_ROOT_SLUG } from 'services/api/ApiContentManager';

export default function InfoPage() {
  // Hooks
  const { t } = useTranslation();
  const scrollableRef = useRef<HTMLDivElement>(null);
  useScrollRestoration(scrollableRef);

  // The categorised Infos page is A/B tested against the flat list: the root
  // category says which one this user gets. An error stays an error (no
  // silent switch to the flat list, which would muddle the analytics).
  const { data: root, isPending, isError } = useCategoryPage(INFO_ROOT_SLUG);

  return (
    <Page>
      <PageTopBar title={t('menu.info')} />
      <PageContent className="gap-4 px-2 pt-2" ref={scrollableRef}>
        {isPending ? (
          <>
            <Skeleton className="h-11 w-full" />
            <Skeleton className="h-16 w-full" />
            <Skeleton className="h-16 w-full" />
            <Skeleton className="h-16 w-full" />
          </>
        ) : isError ? (
          <Empty>
            <EmptyHeader>
              <EmptyDescription>{t('loginRegister.errors.errorOccurred')}</EmptyDescription>
            </EmptyHeader>
          </Empty>
        ) : root.variant === 'v2' ? (
          <InfoHome root={root} />
        ) : (
          <>
            <OctobreRoseCard openedOnPage="info" />
            <ArticlesList allowGridView />
          </>
        )}
      </PageContent>
    </Page>
  );
}
